/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Show_PricingInputs */

const fr_label_show_pricing = /** @type {(inputs: Label_Show_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remontée des prix`)
};

const en_label_show_pricing = /** @type {(inputs: Label_Show_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing display`)
};

/**
* | output |
* | --- |
* | "Pricing display" |
*
* @param {Label_Show_PricingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_show_pricing = /** @type {((inputs?: Label_Show_PricingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Show_PricingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_show_pricing(inputs)
	return en_label_show_pricing(inputs)
});